import React, { useState } from "react";
import Layout from "@/components/Layout";
import { useAuth } from "@/context/AuthContext";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const u = await login(form.email, form.password);
      toast.success(`Welcome back, ${u.name.split(" ")[0]}`);
      if (u.role === "merchant") nav("/merchant");
      else if (u.role === "admin") nav("/admin");
      else nav("/account");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Login failed");
    } finally { setLoading(false); }
  };

  const google = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/account";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <Layout hideFooter>
      <section className="max-w-md mx-auto px-6 py-20" data-testid="login-page">
        <Link to="/" className="block text-center mb-8">
          <span className="font-heading text-3xl">MapleMarket</span>
        </Link>
        <h1 className="font-heading text-4xl text-center mb-2">Welcome back</h1>
        <p className="text-center text-[#5C5A56] text-sm mb-8">Sign in to your account</p>

        <button onClick={google} className="w-full btn-secondary mb-4 inline-flex items-center justify-center gap-2" data-testid="google-login-btn">
          <svg viewBox="0 0 24 24" className="w-4 h-4"><path fill="#4285F4" d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/><path fill="#34A853" d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.99.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/><path fill="#FBBC04" d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/><path fill="#EA4335" d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84C6.71 7.31 9.14 5.38 12 5.38z"/></svg>
          Continue with Google
        </button>

        <div className="flex items-center gap-3 my-5 text-xs text-[#8A8782]">
          <div className="flex-1 h-px bg-[#E5E3DD]" /> OR <div className="flex-1 h-px bg-[#E5E3DD]" />
        </div>

        <form onSubmit={submit} className="space-y-4">
          <Field label="Email" type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} testid="login-email" />
          <Field label="Password" type="password" required value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} testid="login-password" />
          <button type="submit" disabled={loading} className="btn-primary w-full" data-testid="login-submit">
            {loading ? "Signing in…" : "Sign in"}
          </button>
        </form>

        <p className="text-center text-sm text-[#5C5A56] mt-6">
          New to MapleMarket? <Link to="/register" className="text-[#702A32] hover:underline">Create an account</Link>
        </p>
      </section>
    </Layout>
  );
}

function Field({ label, type, required, value, onChange, testid }) {
  return (
    <div>
      <label className="block text-sm font-medium mb-1.5">{label}</label>
      <input type={type} required={required} value={value} onChange={onChange} className="input-field" data-testid={testid} />
    </div>
  );
}
